/* unplugin-vue-components disabled */import { render } from "./courseStatistics.vue?vue&type=template&id=8649c644&scoped=true"
import script from "./courseStatistics.vue?vue&type=script&lang=js"
export * from "./courseStatistics.vue?vue&type=script&lang=js"

import "./courseStatistics.vue?vue&type=style&index=0&id=8649c644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8649c644"]])

export default __exports__